import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Footer from 'pages/LandingPage/components/Footer';
import Navigation from 'pages/LandingPage/components/Navigation';
import type { FC } from 'react';

import Team from './components/Team';
import ZellerInfo from './components/ZellerInfo';

const WhoWeAre: FC = () => {
  return (
    <Box sx={{ backgroundColor: '#F1F6FC', pt: 12 }}>
      <Navigation />
      <ZellerInfo />
      <Box sx={{ background: 'linear-gradient(to left, #15183A, #638DB8)', mb: { xs: 4, sm: 8 } }}>
        <Typography
          color="white"
          sx={{
            fontFamily: 'Roboto',
            fontSize: '22px',
            lineHeight: '25px',
            fontWeight: '500',
            textAlign: 'center',
            p: { xs: 2, sm: 4 },
          }}
        >
          Conduzcamos a una mejor conversión de Leads.
        </Typography>
      </Box>
      <Team />
      <Footer />
    </Box>
  );
};

export default WhoWeAre;
